import { get } from "lodash";

let defaultState = {
	fetching: false,
	list: [],
	errors: [],
	listLoaded: false
}

export default function optionsReducer(state = {
	media: defaultState,
	activity: defaultState
}, action) {
	switch (action.type) {
		case "FETCH_OPTIONS_LIST_PENDING": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...defaultState,
					fetching: true
				}
			}
		}
		case "FETCH_OPTIONS_LIST_REJECTED": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...defaultState,
					errors: get(action.payload, "response.data.errors", ["Fetching data failed"])
				}
			}
		}
		case "FETCH_OPTIONS_LIST_FULFILLED": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...defaultState,
					list: get(action.payload, 'data.list', []),
					listLoaded: true
				}
			}
		}
		case "OPTIONS_ADD_ITEM": {
			const { attribute, data } = action.payload;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					list: [
						...state[attribute].list,
						data
					]
				}
			}
		}
		case "CLEAR_OPTIONS_LIST": {
			const { attribute } = action.payload;
			return {
				...state,
				[attribute]: {
					...defaultState,
					list: [],
					listLoaded: false
				}
			}
		}
		default: {
			return state;
		}
	}
}

